import { getToken } from "js/formatting/getToken";
import config from "config/config";

export async function getPolicyPaymentProfile(policyDetails) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ policyDetails: policyDetails }),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/getpolicypaymentprofile`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
